import type { ParseParams } from 'zod';
import { z } from 'zod';

export const getI18nErrorMap = (
  translateFn: (error: string) => string,
): ParseParams['errorMap'] => {
  return (error, ctx) => {
    const fieldName = error.path[error.path.length - 1];

    let errorKey = '';

    switch (error.code) {
      case z.ZodIssueCode.invalid_type:
      case z.ZodIssueCode.too_small:
        errorKey = `${fieldName}Required`;
        break;
      case z.ZodIssueCode.invalid_string:
        if (error.validation === 'email') {
          errorKey = `${fieldName}Invalid`;
        }

        break;
      case z.ZodIssueCode.too_big:
        errorKey = 'tooLong';
        break;
      default:
        break;
    }

    if (!errorKey.length || !translateFn(errorKey)) {
      return { message: ctx.defaultError };
    }

    return { message: translateFn(errorKey) };
  };
};
